<!--
 * @Author: DY
 * @Date: 2025-02-25 18:22:22
 * @LastEditTime: 2026-07-31 11:53:35
 * @Description: 产成品出库表单【仓储管理-产成品出库】
 * @FilePath: \ShiMoMobile\src\views\storage\finishedProductOutbound\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="finishedProductOutboundForm commonFormStyles">
            <HeaderNav header-title="产成品出库表" left-icon-name="2" :extr="{ leftCallBack: swiperright }"></HeaderNav>
            <section>
                <van-tabs class="currencyTabsStyle" v-model="activeTab" animated :scrollspy="false">
                    <van-tab title="出库信息">
                        <div class="formList">
                            <ul class="formItem">
                                <li class="formItemTitle">
                                    <h5>出库信息</h5>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库单号"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                        v-model="formData.OutstockNumber"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="制单日期"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.BillDate"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        name="radio"
                                        label="出库类型"
                                        class="fieldRadio"
                                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                    >
                                        <template #input>
                                            <van-radio-group
                                                v-model="formData.OutstockType"
                                                direction="horizontal"
                                                :disabled="isDisabled || formData.OutstockCcpCards.length > 0"
                                                ref="outstockTypeRadioGroup"
                                            >
                                                <van-radio v-for="(item, index) in outstockType" :key="`type_${index}`" :name="Number(item.Code)" checked-color="#ee0a24">
                                                    {{ item.Name }}
                                                </van-radio>
                                            </van-radio-group>
                                        </template>
                                    </van-field>
                                </li>
                                <template v-if="![0, 3].includes(formData.OutstockType)">
                                    <li>
                                        <van-field
                                            readonly
                                            label="来源单据编号"
                                            placeholder="选择来源单据"
                                            :disabled="isDisabled"
                                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                            v-model="formData.SourceNumber"
                                            @click="selectSource"
                                        ></van-field>
                                    </li>
                                </template>
                                <template v-if="formData.OutstockType == 1">
                                    <li v-if="isRailwayTransportation">
                                        <van-field
                                            readonly
                                            label="发货通知单编号"
                                            placeholder="选择发货通知单"
                                            :disabled="isDisabled"
                                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                            v-model="formData.DeliveryNoticeNumber"
                                            @click="selectDeliveryNotice"
                                        ></van-field>
                                    </li>
                                    <li>
                                        <van-field
                                            disabled
                                            label="客户名称"
                                            placeholder="选择来源单据编号"
                                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                            v-model="formData.ClientNames"
                                        ></van-field>
                                    </li>
                                    <li>
                                        <van-field
                                            disabled
                                            label="车号"
                                            placeholder="选择来源单据编号"
                                            :left-icon="require('@/assets/images/icons/icon_18@2x.png')"
                                            v-model="formData.CarNumber"
                                        ></van-field>
                                    </li>
                                    <li>
                                        <van-field
                                            disabled
                                            label="短描述"
                                            placeholder="选择来源单据编号"
                                            :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                                            v-model="formData.MaterialShortNames"
                                        ></van-field>
                                    </li>
                                    <li>
                                        <van-field
                                            disabled
                                            label="发货数量(吨)"
                                            placeholder="选择来源单据编号"
                                            :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                                            v-model="formData.SourceWeight"
                                        ></van-field>
                                    </li>
                                    <li v-if="(formData.SourceNumber || '') !== '' && (!isRailwayTransportation || (isRailwayTransportation && (formData.DeliveryNoticeNumber || '') !== ''))">
                                        <van-field
                                            readonly
                                            label="包装袋类型"
                                            placeholder="选择包装袋类型"
                                            :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                            v-model="formData.PackageTypeName"
                                            @click="showSelectPackageType = true;"
                                        ></van-field>
                                    </li>
                                </template>
                                <li>
                                    <van-field
                                        readonly
                                        label="仓库编号"
                                        placeholder="选择仓库"
                                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                        v-model="formData.StockCode"
                                        @click="selectWarehouse"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="仓库名称"
                                        placeholder="选择仓库"
                                        :left-icon="require('@/assets/images/icons/icon_47@2x.png')"
                                        v-model="formData.StockName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        readonly
                                        label="库位编号"
                                        placeholder="选择库位"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                        v-model="formData.GridCode"
                                        @click="selectWarehouseLocation"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="库位名称"
                                        placeholder="选择库位"
                                        :left-icon="require('@/assets/images/icons/icon_32@2x.png')"
                                        v-model="formData.GridName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库总数量（包）"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_16@2x.png')"
                                        v-model="formData.TotalOutstockCount"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库总重量（吨）"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_44@2x.png')"
                                        v-model="formData.TotalOutstockWeight"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库人"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.OutstockUserName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库时间"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.OutstockTime"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库部门"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                                        v-model="formData.OutstockDeptName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="状态"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                        v-model="Status"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        label="备注"
                                        type="textarea"
                                        :rows="2"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                        v-model="formData.Remarks"
                                    ></van-field>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="出库明细">
                        <div class="formList">
                            <ul class="formItem">
                                <li class="formItemTitle">
                                    <h5>出库明细</h5>
                                    <button type="button" v-if="!isDisabled" class="scanCodeButton" @click="scanCodeAdd">
                                        扫码
                                    </button>
                                    <van-icon name="add" v-if="!isDisabled" @click="selectProductCard"></van-icon>
                                </li>
                                <dl class="materialList" v-for="(item, index) in formData.OutstockCcpCards" :key="`material_${index}`">
                                    <dt>
                                        <van-icon name="clear" v-if="!isDisabled" @click="deleteMaterial(index)"></van-icon>
                                        <!-- <h5>产品卡号</h5> -->
                                        <p>{{ item.ProductCardNumber }}</p>
                                    </dt>
                                    <dd>
                                        <div>
                                            <p>物料代码：</p>
                                            <input type="text" disabled v-model="item.MaterialCode">
                                        </div>
                                        <div>
                                            <p>短描述：</p>
                                            <input type="text" disabled v-model="item.MaterialShortName">
                                        </div>
                                        <div>
                                            <p>生产部门/车间：</p>
                                            <input type="text" disabled v-model="item.ProductWorkshopName">
                                        </div>
                                        <div>
                                            <p>生产日期：</p>
                                            <input type="text" disabled v-model="item.ProductDate">
                                        </div>
                                        <div>
                                            <p>单包重量（吨）：</p>
                                            <input type="text" disabled v-model="item.PackageSingleWeight">
                                        </div>
                                        <div>
                                            <p>内部标识：</p>
                                            <input type="text" disabled v-model="item.SignInternal">
                                        </div>
                                    </dd>
                                </dl>
                            </ul>
                        </div>
                    </van-tab>
                </van-tabs>
            </section>
            <footer class="currencyFooterStyle">
                <template v-if="!isDisabled">
                    <button class="confirm" v-if="(formData.Id || '') != ''" @click="submitForm">
                        确认出库
                    </button>
                    <button class="confirm" @click="saveForm">
                        保存
                    </button>
                </template>
                <button class="confirm" @click="closeAllocationForm">
                    关闭
                </button>
            </footer>
            <van-dialog v-model="confirmDialog" title="出库确认" show-cancel-button class="confirmPopUp" @confirm="confirmClick">
                <table>
                    <thead>
                        <tr>
                            <th>短描述</th>
                            <th>入库数量(吨)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in confirmMaterialList" :key="`material_${index}`">
                            <td>{{ item.MaterialShortName }}</td>
                            <td>{{ item.PackageSingleWeight }}</td>
                        </tr>
                        <tr>
                            <th>总计</th>
                            <th>{{ confirmTotal }}</th>
                        </tr>
                    </tbody>
                </table>
            </van-dialog>
            <van-action-sheet v-model="showSelectPackageType" cancel-text="取消" :actions="packageTypeList" @select="confirmSelectionPackageType"></van-action-sheet>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import currencyFun from '@/assets/js/currencyFun/index.js';
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
export default {
    name: 'finished-product-outbound-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/finishedProductOutbound') {
            this.$store.commit('noKeepAlive', 'finished-product-outbound-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            isDisabled: false,
            activeTab: 0,
            outstockType: [],
            formData: {
                Id: '',
                OutstockNumber: '',
                BillDate: '',
                OutstockType: null,
                OutstockTypeDic: [],
                SaleOutstockType: 0,
                SourceId: '',
                SourceNumber: '',
                SourceContractNos: '',
                DeliveryNoticeId: '',
                DeliveryNoticeNumber: '',
                ClientNames: '',
                CarNumber: '',
                StockId: '',
                StockCode: '',
                StockName: '',
                GridId: '',
                GridCode: '',
                GridName: '',
                Status: 0,
                StatusName: '',
                TotalOutstockCount: 0,
                TotalOutstockWeight: 0,
                OutstockUserName: '',
                OutstockTime: '',
                OutstockDeptName: '',
                OutstockDeptId: '',
                Remarks: '',
                IsHaveProductCard: true,
                OutstockCcpCards: [],
                MaterialCodes: '',
                MaterialShortNames: '',
                SourceWeight: 0,
                PackageType: '',
                PackageTypeName: '',
                ContractPackageType: '',
                ContractPackageTypeName: '',
            },
            Status: '',
            currentMaterial: {},

            confirmDialog: false,
            confirmMaterialList: [],
            confirmTotal: 0,

            isRailwayTransportation: false,

            showSelectPackageType: false,
            packageTypeList: [],
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.source) {
            this.formData.SourceId = this.$route.params.source[0].id;
            this.formData.SourceNumber = this.$route.params.source[0].transport_number;
            this.formData.MaterialCodes = this.$route.params.source[0].material_codes || this.$route.params.source[0].material_code;
            this.formData.MaterialShortNames = this.$route.params.source[0].material_short_names || this.$route.params.source[0].material_short_name;
            if ((this.$route.params.code || '') !== '') {
                this.formData.ClientNames = this.$route.params.source[0].client_names;
                this.formData.CarNumber = this.$route.params.source[0].car_number;
            }
            if (this.formData.SourceNumber.includes('TY')) {
                this.formData.SourceWeight = this.$route.params.source[0].delivery_weight;
                this.isRailwayTransportation = true;

                this.packageTypeList = [];
                this.formData.PackageTypeName = '';
                this.formData.PackageType = '';
            } else {
                this.formData.SourceWeight = this.$route.params.source[0].delivery_weight_new;
                this.isRailwayTransportation = false;
            }
            this.loadPackageType(this.$route.params.source[0]);

            this.resetWarehouseLocation();
        }
        if (this.$route.params.mixingNotice) {
            this.formData.SourceId = this.$route.params.mixingNotice[0].id;
            this.formData.SourceNumber = this.$route.params.mixingNotice[0].merge_notice_number;
            this.formData.SourceContractNos = this.$route.params.mixingNotice[0].contract_no;
            this.formData.MaterialCodes = this.$route.params.mixingNotice[0].all_material_code;
            this.formData.MaterialShortNames = this.$route.params.mixingNotice[0].all_material_short_name;
            this.resetWarehouseLocation();
        }
        if (this.$route.params.deliveryNotice) {
            this.formData.DeliveryNoticeId = this.$route.params.deliveryNotice[0].id;
            this.formData.DeliveryNoticeNumber = this.$route.params.deliveryNotice[0].delivery_notice_number;

            this.loadPackageType(this.$route.params.deliveryNotice[0]);
        }
        if (this.$route.params.warehouse) {
            this.formData.StockId = this.$route.params.warehouse[0].id;
            this.formData.StockCode = this.$route.params.warehouse[0].stock_code;
            this.formData.StockName = this.$route.params.warehouse[0].stock_name;
            this.formData.GridId = '';
            this.formData.GridCode = '';
            this.formData.GridName = '';
        }
        if (this.$route.params.warehouseLocation) {
            this.formData.GridId = this.$route.params.warehouseLocation[0].grid_id;
            this.formData.GridCode = this.$route.params.warehouseLocation[0].grid_code;
            this.formData.GridName = this.$route.params.warehouseLocation[0].grid_name;
        }
        if (this.$route.params.productCard) {
            const productCards = this.formData.OutstockCcpCards.map(item => item.ProductCardNumber);
            this.$route.params.productCard.forEach(item => {
                if (!productCards.includes(item.product_card_number)) {
                    this.formData.OutstockCcpCards.unshift({
                        Id: '',
                        ProductCardNumber: item.product_card_number,
                        MaterialCode: item.material_code,
                        MaterialShortName: item.material_short_name,
                        ProductWorkshopName: item.product_workshop_name,
                        ProductDate: item.product_date,
                        PackageSingleWeight: item.package_single_weight,
                        SignInternal: item.sign_internal,
                    });
                }
            });
            this.loadTotal();
        }
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        async initpage() {
            this.$toast.loading({ overlay: true, duration: 0 });
            try {
                window.jyCallback_DriveScanFinished = this.jyCallback_DriveScanFinished_ccpck;
                const type = this.$route.params.type;
                this.outstockType = await this.getOutstockType();
                if (type === 'new') {
                    this.formData.BillDate = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd HH:mm:ss');
                }
                if (type === 'see') {
                    this.isDisabled = true;
                }
                if (type === 'edit' || type === 'see') {
                    this.formData = await this.getFormData(this.$route.params.id);
                    this.formData.DeliveryNoticeId = this.formData.DeliveryNoticeId || '';
                    this.formData.DeliveryNoticeNumber = this.formData.DeliveryNoticeNumber || '';
                    if ((this.formData.SourceNumber || '').includes('TY')) {
                        this.isRailwayTransportation = true;
                    } else {
                        this.isRailwayTransportation = false;
                    }
                    const packageType = (this.formData.ContractPackageType || '').split(',');
                    const packageTypeName = (this.formData.ContractPackageTypeName || '').split(',');
                    const packageTypeList = [];
                    (packageType || []).forEach((item, index) => {
                        if (this.formData.PackageType === item) {
                            this.formData.PackageTypeName = packageTypeName[index];
                        }
                        packageTypeList.push({
                            name: packageTypeName[index],
                            value: item,
                        });
                    });
                    this.packageTypeList = packageTypeList;
                }
                this.Status = this.loadStatus(this.formData.Status);

                // 确保在设置初始值后再绑定事件
                this.$nextTick(() => {
                    this.$refs.outstockTypeRadioGroup.$on('change', this.selectOutboundType);
                });
            } finally {
                this.$toast.clear();
            }
        },

        loadStatus(nub) {
            const staus = ['未出库', '出库中', '已出库'];
            return staus[nub];
        },

        resetWarehouseLocation() {
            this.formData.DeliveryNoticeId = '';
            this.formData.DeliveryNoticeNumber = '';
            this.formData.StockId = '';
            this.formData.StockCode = '';
            this.formData.StockName = '';
            this.formData.GridId = '';
            this.formData.GridCode = '';
            this.formData.GridName = '';
        },

        selectOutboundType() {
            this.formData.SourceId = '';
            this.formData.SourceNumber = '';
            this.formData.MaterialCodes = '';
            this.formData.MaterialShortNames = '';

            this.formData.ContractPackageType = '';
            this.formData.ContractPackageTypeName = '';
            this.packageTypeList = [];
            this.formData.PackageTypeName = '';
            this.formData.PackageType = '';

            this.resetWarehouseLocation();
        },

        selectSource() {
            if (this.isDisabled) {return;}
            if (!this.formData.OutstockType) {
                this.$toast('请选择出库类型');
                return;
            }
            this.$router.isBack = 2;
            if (this.formData.OutstockType === 1) {
                this.$router.replace({
                    name: 'selectManyListView',
                    params: {
                        pageTitle: ['铁运单', '汽运单'],
                        sourcePath: 'finishedProductOutboundForm',
                        listCode: ['outstock_choose_transport_railway', 'outstock_choose_transport_truck'],
                        requestUrl: ['/basicplatform/tabledata', '/basicplatform/tabledata'],
                        callbackDataKey: 'source',
                        relationKey: 'id',
                        indexKey: 'page',
                        sizeKey: 'limit',
                        headerList: [
                            [{
                                name: '铁运单号',
                                code: 'transport_number',
                                isTitle: true,
                            }, {
                                name: '客户名称',
                                code: 'client_names',
                                icon: 'icon_1@2x',
                            }, {
                                name: '发货日期',
                                code: 'loading_date',
                                icon: 'icon_7@2x',
                            }, {
                                name: '货票号',
                                code: 'number_95306',
                                icon: 'icon_18@2x',
                            }, {
                                name: '货物名称',
                                code: 'material_short_names',
                                icon: 'icon_5@2x',
                            }, {
                                name: '货位',
                                code: 'goods_location',
                                icon: 'icon_23@2x',
                            }, {
                                name: '数量',
                                code: 'delivery_weight',
                                icon: 'icon_6@2x',
                            }, {
                                name: '已发数量',
                                code: 'package_single_weight',
                                icon: 'icon_6@2x',
                            }, {
                                name: '发站',
                                code: 'leave_station',
                                icon: 'icon_3@2x',
                            }, {
                                name: '到站',
                                code: 'arrive_station',
                                icon: 'icon_3@2x',
                            }, {
                                name: '收货人',
                                code: 'receiver_name',
                                icon: 'icon_8@2x',
                            }, {
                                name: '收货人电话',
                                code: 'receiver_phone',
                                icon: 'icon_9@2x',
                            }, {
                                name: '经办人',
                                code: 'creator',
                                icon: 'icon_8@2x',
                            }, {
                                name: '备注',
                                code: 'remarks',
                                icon: 'icon_10@2x',
                            }],
                            [{
                                name: '汽运单号',
                                code: 'transport_number',
                                isTitle: true,
                            }, {
                                name: '客户名称',
                                code: 'client_names',
                                icon: 'icon_1@2x',
                            }, {
                                name: '物料代码',
                                code: 'all_material_code',
                                icon: 'icon_28@2x',
                            }, {
                                name: '短描述',
                                code: 'all_material_short_name',
                                icon: 'icon_28@2x',
                            }, {
                                name: '发货数量（吨）',
                                code: 'delivery_weight_new',
                                icon: 'icon_6@2x',
                            }, {
                                name: '出库数量（吨）',
                                code: 'delivery_weight',
                                icon: 'icon_6@2x',
                            }, {
                                name: '车牌号',
                                code: 'car_number',
                                icon: 'icon_36@2x',
                            }, {
                                name: '司机',
                                code: 'driver_name',
                                icon: 'icon_8@2x',
                            }, {
                                name: '司机电话',
                                code: 'driver_phone',
                                icon: 'icon_9@2x',
                            }, {
                                name: '登记人',
                                code: 'creator',
                                icon: 'icon_8@2x',
                            }, {
                                name: '登记时间',
                                code: 'creation_time',
                                icon: 'icon_7@2x',
                            }, {
                                name: '备注',
                                code: 'remarks',
                                icon: 'icon_10@2x',
                            }],
                        ],
                    },
                });
            } else if (this.formData.OutstockType === 2) {
                this.$router.replace({
                    name: 'selectListView',
                    params: {
                        pageTitle: '选择混料通知单',
                        sourcePath: 'finishedProductOutboundForm',
                        requestUrl: `/basicplatform/tabledata?frameId=frameIdoutstock_ccp_form&stock_code=${this.formData.StockCode}&grid_code=${this.formData.GridCode}`,
                        listCode: 'choose_merge_notice_confirmed',
                        callbackDataKey: 'mixingNotice',
                        relationKey: 'id',
                        indexKey: 'page',
                        sizeKey: 'limit',
                        headerList: [{
                            name: '混料通知单号',
                            code: 'merge_notice_number',
                            isTitle: true,
                        }, {
                            name: '合同编号',
                            code: 'contract_no',
                            icon: 'icon_1@2x',
                        }, {
                            name: '客户名称',
                            code: 'client_name',
                            icon: 'icon_1@2x',
                        }, {
                            name: '混料结果代码',
                            code: 'all_material_code',
                            icon: 'icon_46@2x',
                        }, {
                            name: '混料结果短描述',
                            code: 'all_material_short_name',
                            icon: 'icon_28@2x',
                        }, {
                            name: '混料明细代码',
                            code: 'details_material_code',
                            icon: 'icon_46@2x',
                        }, {
                            name: '混料明细短描述',
                            code: 'details_material_short_name',
                            icon: 'icon_28@2x',
                        }, {
                            name: '成品数量（吨）',
                            code: 'product_weight',
                            icon: 'icon_38@2x',
                        }, {
                            name: '确认时间',
                            code: 'confirm_time',
                            icon: 'icon_7@2x',
                        }, {
                            name: '登记人',
                            code: 'creator',
                            icon: 'icon_8@2x',
                        }, {
                            name: '备注',
                            code: 'remarks',
                            icon: 'icon_10@2x',
                        }],
                    },
                });
            }
        },
        // 选择发货通知单
        selectDeliveryNotice() {
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择发货通知单',
                    sourcePath: 'finishedProductOutboundForm',
                    listCode: 'outstock_choose_delivery_notice',
                    requestUrl: `/basicplatform/tabledata?transport_id=${this.formData.SourceId}`,
                    callbackDataKey: 'deliveryNotice',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '发货通知单号',
                        code: 'delivery_notice_number',
                        isTitle: true,
                    }, {
                        name: '合同编号',
                        code: 'contract_no',
                        icon: 'icon_1@2x',
                    }, {
                        name: '客户名称',
                        code: 'client_name',
                        icon: 'icon_29@2x',
                    }, {
                        name: '物料名称',
                        code: 'material_short_names',
                        icon: 'icon_32@2x',
                    }, {
                        name: '业务员名称',
                        code: 'salesman_name',
                        icon: 'icon_8@2x',
                    }, {
                        name: '发货日期',
                        code: 'delivery_date',
                        icon: 'icon_7@2x',
                    }, {
                        name: '发货通知单数量（吨）',
                        code: 'delivery_weight',
                        icon: 'icon_16@2x',
                    }, {
                        name: '备注',
                        code: 'remarks',
                        icon: 'icon_10@2x',
                    }],
                },
            });
        },
        loadPackageType(data) {
            const packageType = (data.package_type || '').split(',');
            const packageTypeName = (data.package_type_name || '').split(',');
            const packageTypeList = [];
            (packageType || []).forEach((item, index) => {
                packageTypeList.push({
                    name: packageTypeName[index],
                    value: item,
                });
            });
            this.packageTypeList = packageTypeList;
            if ((packageTypeList || []).length === 1) {
                this.formData.PackageTypeName = this.packageTypeList[0].name;
                this.formData.PackageType = this.packageTypeList[0].value;
            } else {
                this.formData.PackageTypeName = '';
                this.formData.PackageType = '';
            }

            this.formData.ContractPackageType = data.package_type;
            this.formData.ContractPackageTypeName = data.package_type_name;
        },
        confirmSelectionPackageType(item) {
            this.showSelectPackageType = false;
            this.formData.PackageTypeName = item.name;
            this.formData.PackageType = item.value;
        },
        selectWarehouse() {
            if (this.isDisabled) {return;}
            if (![0, 3].includes(this.formData.OutstockType)) {
                if ((this.formData.SourceNumber || '') === '') {
                    this.$toast.fail('请先选择来源单据！');
                    return;
                }
            }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择仓库',
                    sourcePath: 'finishedProductOutboundForm',
                    requestUrl: '/basicplatform/tabledata?isFilter=0',
                    listCode: 'instock_ccp_xzck',
                    callbackDataKey: 'warehouse',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '仓库编号',
                        code: 'stock_code',
                        isTitle: true,
                    }, {
                        name: '仓库名称',
                        code: 'stock_name',
                        icon: 'icon_5@2x',
                    }],
                },
            });
        },

        selectWarehouseLocation() {
            if (this.isDisabled) {return;}
            if ((this.formData.StockId || '') === '') {
                this.$toast.fail('请先选择仓库！');
                return;
            }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择库位',
                    sourcePath: 'finishedProductOutboundForm',
                    requestUrl: `/basicplatform/tabledata?&material_code=${this.formData.MaterialCodes}&stock_id=${this.formData.StockId}`,
                    listCode: 'choose_stock_grid',
                    callbackDataKey: 'warehouseLocation',
                    relationKey: 'grid_id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '库位编号',
                        code: 'grid_code',
                        isTitle: true,
                    }, {
                        name: '库位名称',
                        code: 'grid_name',
                        icon: 'icon_5@2x',
                    }, {
                        name: '仓库编号',
                        code: 'stock_code',
                        icon: 'icon_34@2x',
                    }, {
                        name: '仓库名称',
                        code: 'stock_name',
                        icon: 'icon_47@2x',
                    }, {
                        name: '物料代码',
                        code: 'material_codes',
                        icon: 'icon_28@2x',
                    }, {
                        name: '当前数量',
                        code: 'volume_current',
                        icon: 'icon_6@2x',
                    }, {
                        name: '管理部门',
                        code: 'manage_dept_name',
                        icon: 'icon_29@2x',
                    }, {
                        name: '管理员',
                        code: 'storeman_name',
                        icon: 'icon_8@2x',
                    }],
                },
            });
        },

        selectProductCard() {
            if ((this.formData.GridCode || '') === '' || (this.formData.StockCode || '') === '') {
                this.$toast.fail('请先选择库位！');
                return;
            }
            const selectedCards = this.formData.OutstockCcpCards.map(item => item.ProductCardNumber).join(',');
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择产品卡',
                    sourcePath: 'finishedProductOutboundForm',
                    requestUrl: `/basicplatform/tabledata?frameId=frameIdoutstock_ccp_form&stock_code=${this.formData.StockCode}&grid_code=${this.formData.GridCode}&selectedCards=${selectedCards}&material_codes=${this.formData.MaterialCodes}`,
                    listCode: 'outstock_choose_product_card',
                    callbackDataKey: 'productCard',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    type: 'checkbox',
                    pageSize: 100,
                    showTotal: true,
                    totalKey: 'package_single_weight',
                    headerList: [{
                        name: '产品卡号',
                        code: 'product_card_number',
                        isTitle: true,
                    }, {
                        name: '批次号',
                        code: 'batch_number',
                        icon: 'icon_18@2x',
                    }, {
                        name: '物料代码',
                        code: 'material_code',
                        icon: 'icon_46@2x',
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '单包重量（吨）',
                        code: 'package_single_weight',
                        icon: 'icon_16@2x',
                    }, {
                        name: '内部标识',
                        code: 'sign_internal',
                        icon: 'icon_43@2x',
                    }, {
                        name: '生产日期',
                        code: 'product_date',
                        icon: 'icon_7@2x',
                    }, {
                        name: '备注',
                        code: 'remarks',
                        icon: 'icon_10@2x',
                    }],
                },
            });
        },

        scanCodeAdd() {
            if ((this.formData.Id || '') === '') {
                this.$toast.fail('请先保存出库单！');
                return;
            }
            this.$callMobile('JYExternalNative', 'jyDriveScanClick');
        },
        async jyCallback_DriveScanFinished_ccpck(val) {
            const data = JSON.parse(`${val}`.slice(1, -1));
            const res = await this.addDetails(this.formData.GridCode, data.ProductCardNumber);
            if (res) {
                // 检查是否已存在相同的产品卡
                const isDuplicate = this.formData.OutstockCcpCards.some(
                    card => card.ProductCardNumber === res.ProductCardNumber
                );
                if (isDuplicate) {
                    this.$toast.fail('该产品卡已添加');
                    return;
                }
                this.formData.OutstockCcpCards.unshift({
                    Id: res.Id,
                    ProductCardNumber: res.ProductCardNumber,
                    MaterialCode: res.MaterialCode,
                    MaterialShortName: res.MaterialShortName,
                    ProductWorkshopName: res.ProductWorkshopName,
                    ProductDate: res.ProductDate,
                    PackageSingleWeight: res.PackageSingleWeight,
                    SignInternal: res.SignInternal,
                });
                this.loadTotal();
                this.$toast.success('添加成功');
            } else {
                this.$toast.fail('未获取到产品卡信息，请重新扫描！');
            }
        },

        deleteMaterial(index) {
            this.formData.OutstockCcpCards.splice(index, 1);
            this.loadTotal();
        },

        loadTotal() {
            this.formData.TotalOutstockCount = this.formData.OutstockCcpCards.length;
            this.formData.TotalOutstockWeight = this.formData.OutstockCcpCards.reduce((pre, cur) => {
                return NP.plus(pre, cur.PackageSingleWeight);
            }, 0);
        },

        async saveForm() {
            if (this.isRailwayTransportation && (this.formData.DeliveryNoticeNumber || '') === '') {
                this.$toast.fail('请先选择发货通知单编号！');
                return;
            }
            this.$toast.loading({ overlay: true, duration: 0 });
            try {
                const ProductCardNumber = this.formData.OutstockCcpCards.map(item => item.ProductCardNumber);
                const requestData = {
                    Id: this.formData.Id,
                    OutstockNumber: this.formData.OutstockNumber,
                    OutstockType: this.formData.OutstockType,
                    SaleOutstockType: this.formData.SaleOutstockType,
                    SourceId: this.formData.SourceId,
                    SourceNumber: this.formData.SourceNumber,
                    SourceContractNos: this.formData.SourceContractNos,
                    DeliveryNoticeId: this.formData.DeliveryNoticeId,
                    DeliveryNoticeNumber: this.formData.DeliveryNoticeNumber,
                    MaterialCodes: this.formData.MaterialCodes,
                    MaterialShortNames: this.formData.MaterialShortNames,
                    StockId: this.formData.StockId,
                    StockCode: this.formData.StockCode,
                    StockName: this.formData.StockName,
                    GridId: this.formData.GridId,
                    GridCode: this.formData.GridCode,
                    GridName: this.formData.GridName,
                    ClientNames: this.formData.ClientNames,
                    CarNumber: this.formData.CarNumber,
                    Status: 0,
                    ChoosedProductCards: ProductCardNumber,
                    SourceWeight: this.formData.SourceWeight,
                    PackageType: this.formData.PackageType,
                    PackageTypeName: this.formData.PackageTypeName,
                    ContractPackageType: this.formData.ContractPackageType,
                    ContractPackageTypeName: this.formData.ContractPackageTypeName,
                };
                const res = await this.saveFormData(requestData);
                if (res) {
                    this.formData = await this.getFormData(res.Id);
                    this.formData.PackageTypeName = requestData.PackageTypeName;
                    this.$toast.success('保存成功。');
                }
            } finally {
                this.$toast.clear();
            }

        },
        async submitForm() {
            if ((this.formData.OutstockCcpCards || []).length === 0) {
                this.$toast.fail('请先添加产品卡！');
                return;
            }
            if (this.formData.OutstockType === 1 && (this.formData.SourceNumber || '') !== '' && (!this.isRailwayTransportation || this.isRailwayTransportation && (this.formData.DeliveryNoticeNumber || '') !== '') && (this.formData.PackageTypeName || '') === '') {
                this.$toast.fail('选择包装袋类型！');
                return;
            }
            const materialMap = this.formData.OutstockCcpCards.reduce((acc, cur) => {
                const key = cur.MaterialShortName;
                if (!acc[key]) {
                    acc[key] = { MaterialShortName: key, PackageSingleWeight: 0 };
                }
                acc[key].PackageSingleWeight = NP.plus( acc[key].PackageSingleWeight, Number(cur.PackageSingleWeight || 0));
                return acc;
            }, {});
            this.confirmMaterialList = Object.values(materialMap).map(item => ({ ...item, PackageSingleWeight: NP.round(item.PackageSingleWeight, 4) }));
            this.confirmTotal = NP.round(this.confirmMaterialList.reduce((sum, item) => NP.plus(sum, item.PackageSingleWeight), 0), 4);
            this.confirmDialog = true;
        },
        async confirmClick() {
            if (this.formData.OutstockType === 1 || this.formData.OutstockType === '1') {
                if ((this.confirmTotal || 0) > (this.formData.SourceWeight || 0)) {
                    this.$toast.fail('出库数量大于发货数量，不允许出库！');
                } else if ((this.confirmTotal || 0) < (this.formData.SourceWeight || 0)) {
                    this.$dialog.confirm({
                        title: '出库确认',
                        message: '出库数量小于发货数量，是否出库？',
                    }).then(() => {
                        this.confirmRequest();
                    });
                } else {
                    this.confirmRequest();
                }
            } else {
                this.confirmRequest();
            }
        },

        async confirmRequest() {
            this.$toast.loading({ overlay: true, duration: 0 });
            const res = await this.submitFormData(this.formData.Id);
            if (res) {
                this.$toast.success('确认成功。');
                this.closeAllocationForm();
            }
            this.$toast.clear();
        },

        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'finishedProductOutbound',
                params: {
                    saveCallback: true,
                },
            });
        },

        getOutstockType() {
            return this.$axios.$get('/interfaceApi/sale/outstock/outstock_type_dic');
        },
        getFormData(id) {
            return this.$axios.$get(`/interfaceApi/sale/outstock/outstock_ccp_single?id=${id}`);
        },
        addDetails(gridCode, productCardNumber) {
            const url = `gridCode=${gridCode}&productCardNumber=${productCardNumber}`;
            return this.$axios.$get(`/interfaceApi/sale/outstock/outstock_ccp_check_card?${url}`);
        },
        saveFormData(requestData) {
            return this.$axios.$post('/interfaceApi/sale/outstock/outstock_ccp_save', requestData);
        },
        submitFormData(id) {
            return this.$axios.$get(`/interfaceApi/sale/outstock/outstock_ccp_confirm?id=${id}`);
        },
    },
    beforeDestroy() {},
};
</script>
<style lang="stylus">
.finishedProductOutboundForm
    background #F0F0F0
    section
        height 0
        flex 1
    .formList
        padding 10rpx
        .formItem
            background #fff
            .formItemTitle
                .scanCodeButton
                    color #E93743
                    font-size 12rpx
                    margin-right auto
                    margin-left 10rpx
                    width: 52rpx;
                    height: 26rpx;
                    line-height 24rpx;
                    background: rgba(233,55,67,0.1);
                    border-radius: 2rpx;
                    border: 1px solid rgba(233,55,67,0.2)
        .materialList
            margin 10rpx
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
            border-radius: 4rpx;
            overflow hidden
            dt
                height 42rpx
                background: #F8F8F8;
                border-bottom: 1px solid #E7E6E6;
                display flex
                align-items center
                padding 0 14rpx
                .van-icon
                    color #E93543
                    font-size 16rpx
                    margin-right 10rpx
                // h5
                //     font-size 16rpx
                //     color #e93743
                p
                    // margin-left auto
                    color #e93743
            dd
                padding 7rpx
                display flex
                flex-wrap wrap
                div
                    width 50%
                    padding 7rpx
                    p
                        font-size 14rpx
                        color #626262
                        margin-bottom 6rpx
                    input
                        width 100%
                        height: 40px;
                        padding 0 6rpx
                        background: #FAFBFE;
                        border-radius: 4px;
                        border: 1px solid #ADC7E0;
                        &[disabled]
                            background: #F8F8F8
                            border-color #D7D7D7
                            color rgba(98, 98, 98, 0.7)
                            -webkit-text-fill-color rgba(98, 98, 98, 0.7)
    .confirmPopUp
        width 90%
        border-radius 8rpx
        .van-dialog__header
            font-size 16rpx
            color #E93543
            padding 14rpx 0
            border-bottom 1px solid rgba(231, 230, 230, 1)
            background: linear-gradient( 180deg, #FFF4F2 0%, #FFFFFF 100%);
        .van-dialog__content
            padding 10rpx
            max-height: 60vh;
            overflow-y: auto;
            table
                width 100%
                border-collapse collapse;
                box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
                border-radius: 4px;
                border: 1px solid #E7E6E6;
                overflow: hidden;
                th,td
                    border 1px solid #E7E6E6
                    font-size 14rpx
                    text-align center
                    height 36rpx
</style>
